<template>
  <div ref="attrTabRef" >

    <div class="d-flex">
      <feather-icon
          icon="UserIcon"
          size="19"
      />
      <h4 class="mb-0 ml-50">
        {{ $t('Device Attributes')}}
      </h4>
    </div>


    <b-form class="mt-2">
      <b-row >
        <b-col cols="12">
          <!-- Row Loop -->
          <b-row v-for="(item, index) in deviceData.attributes" :id="item.id" :key="index" ref="rowRef">

            <!-- Item Key -->
            <b-col md="5">
              <b-form-group :label="$t('Attribute Key')">
                <v-select :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :reduce="key => key.title"
                          label="title" :options="attrsOptions" v-model="item.key"
                />
              </b-form-group>
            </b-col>


            <!-- Value -->
            <b-col md="5">
              <b-form-group :label="$t('value')">
                <b-form-input v-model="item.value"/>
              </b-form-group>
            </b-col>


            <!-- Remove Button -->
            <b-col lg="2" md="2" class="mb-50">
              <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-0 mt-md-2"
                  @click="removeItem(deviceData.attributes, index)"
              >
                <feather-icon icon="XIcon" class="mr-25"/>
                <span>{{ $t('Delete')}}</span>
              </b-button>
            </b-col>

          </b-row>
        </b-col>

        <b-col cols="12">
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary" @click="newAttr">
            <feather-icon icon="PlusIcon" class="mr-25"/>
            <span>{{ $t('Add Attribute') }}</span>
          </b-button>
        </b-col>

        <b-col cols="12"><hr></b-col>

      </b-row>

    </b-form>

  </div>

</template>

<script>

import {
  BButton,
  BCard, BCol,
  BForm, BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { OrbitSpinner } from 'epic-spinners'
import { ref, onMounted, onUnmounted, computed } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import useRepeater from '@/views/modules/useRepeater'

export default {
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCard,
    BCol,
    BAlert,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner
  },

  setup(props, {root}) {

    const { initTrHeight, repeatAgain, removeItem, attrTabRef, rowRef } = useRepeater(root)

    window.addEventListener('resize', initTrHeight)

    onMounted(() => {
      initTrHeight()
    })

    onUnmounted(() => {
      window.removeEventListener('resize', initTrHeight)
    })

    const attrsOptions = [
      { title: 'speedLimit'},
      { title: 'serviceSpeed'},
    ]

    const newAttr = () => {
      const attrs = repeatAgain(deviceData.value.attributes)
      root.$store.dispatch('device/updateAttributes', attrs)
    }

    const deviceData = computed(() => root.$store.state.device.data)

    return {
      deviceData,
      newAttr,

      removeItem,
      repeatAgain,
      attrTabRef,
      rowRef,
      attrsOptions
    }
  }

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
